import React from "react";
import {Alert, AlertTitle} from "@mui/material";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Alert content.
     */
    children?: string
}

/**
 * Displays an error alert whose content is customizable.
 * @author Alizée Grand
 * @version 1.0
 * @creation 20/04/2022
 * @last_update 20/04/2022
 **/
class Error extends React.Component<Props> {

    render() {

        return (
            <Alert severity="error">
                <AlertTitle>{this.props.t("utils.alert.error.title")}</AlertTitle>
                {this.props.children}
            </Alert>
        );

    };

}

export default withTranslation()(Error);
